import { GetterTree } from 'vuex';
import { InterviewRequestState, BasicDetails, InterviewDetails, SubmissionVariables } from './types';

const getters: GetterTree<InterviewRequestState, any> = {
  sitter: (state) => state.sitter,

  sitterUuid: (state) => state.sitterUuid,

  sitterDisplayName: (state) => state.sitter?.displayName || 'the sitter',

  sitterFallback: (state) => {
    if (!state.sitter) return 'the sitter';
    return state.sitter.displayName || 'the sitter';
  },

  basicDetails: (state): BasicDetails => ({
    startTime: state.startTime,
    endTime: state.endTime,
    virtual: state.virtual,
    address: state.address,
    geoPointX: state.geoPointX,
    geoPointY: state.geoPointY,
  }),

  interviewDetails: (state): InterviewDetails => ({
    jobTitle: state.jobTitle,
    jobUuid: state.jobUuid,
    careType: state.careType,
    details: state.details,
  }),

  submissionVariables: (state, _getters, _rootState, rootGetters): SubmissionVariables => {
    let geoPoint: { x: string; y: string } | null = null;
    let locationDetails: string;

    // Handle virtual vs in-person location logic
    // Check if it's virtual (boolean true or string 'phone')
    const isVirtual = state.virtual === true || (state.virtual as any) === 'phone';

    if (isVirtual) {
      // For virtual interviews, set details to indicate it's virtual and geoPoint to null
      locationDetails = 'Phone interview';
      geoPoint = null;
    } else {
      // For in-person interviews, use the address and coordinates
      locationDetails = state.address || '';
      if (state.geoPointX && state.geoPointY) {
        geoPoint = {
          x: `${state.geoPointX}`,
          y: `${state.geoPointY}`,
        };
      }
    }

    const output: SubmissionVariables = {
      start: state.startTime,
      end: state.endTime,
      sitter: {
        id: state.sitterUuid || '',
        displayName: state.sitter?.displayName || '',
      },
      parent: {
        firstName: rootGetters['account/getAccount']?.firstName || '',
        lastName: rootGetters['account/getAccount']?.lastName || '',
      },
      location: {
        details: locationDetails,
        geoPoint,
      },
      familyMembers: [],
      details: state.details,
      petInfo: [],
      rate: 0,
      careType: state.careType,
    };

    if (state.jobUuid) {
      output.jobUuid = state.jobUuid;
    }

    return output;
  },

  formattedAddress: (state): string => {
    if (!state.address) return '';
    return state.address;
  },
};

export default getters;
